export default __webpack_public_path__ + "9e3c9f7562e07ef8dd4c8bb79115c055.svg";